import styled from "styled-components";
import { FC, PropsWithChildren } from "react";

import Text from "@/components/Text";

const Box = styled.div`
  margin-bottom: 12px;
  background: ${({ theme }) => theme.colors.grayscale};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  padding: 16px 24px;
`;

export const Li = styled.li`
  position: relative;
  padding-left: 12px;
  margin-bottom: 8px;
  &:after {
    content: "";
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    left: 0;
    top: 6px;
    background: ${({ theme }) => theme.colors.purpleLight};
  }
`;

const StyledText = styled(Text)`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  svg {
    margin-right: 8px;
    margin-top: -2px;
  }
`;

interface Props {
  heading?: string;
  className?: string;
}

const Notes: FC<PropsWithChildren<Props>> = ({
  children,
  heading = "Notes",
  className,
}) => {
  return (
    <Box className={className}>
      <StyledText $type="smallBold" $color="purple">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="12"
            fill="currentColor"
            fillOpacity="0.08"
          />
          <path
            d="M10 16.5H14"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 18.5H13.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.99957 14.4997C8.16014 13.87 7.54012 12.9921 7.22731 11.9905C6.91451 10.9888 6.92478 9.91411 7.25667 8.91861C7.58856 7.92311 8.22525 7.05727 9.07655 6.44371C9.92786 5.83016 10.9506 5.5 12 5.5C13.0494 5.5 14.0721 5.83015 14.9234 6.44371C15.7747 7.05726 16.4114 7.9231 16.7433 8.9186C17.0752 9.91409 17.0855 10.9888 16.7727 11.9904C16.4599 12.9921 15.8399 13.87 15.0004 14.4997"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {heading}
      </StyledText>
      <>{children}</>
    </Box>
  );
};

export default Notes;
